import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../utils/useAuth";

export default function Protected({ children, role }) {
  const { user, profile, effectiveRole } = useAuth();

  if (!user) return <Navigate to="/" replace />;

  // Profile still loading?
  if (!profile) return <div className="p-6">Loading profile…</div>;

  // Not approved → force pending
  if (!profile.approved) return <Navigate to="/pending" replace />;

  // -----------------------------
  // ADMIN SPECIAL RULE
  // -----------------------------
  if (profile.role === "admin") {
    // Admin can always access admin pages
    if (role === "admin" && effectiveRole === "admin") return children;

    // Admin impersonating another role
    if (role && role !== effectiveRole) {
      // Let Navbar/Login redirect — do NOT block
      return <div className="p-6">Loading…</div>;
    }

    return children;
  }

  // -----------------------------
  // NON-ADMIN STRICT ROLE MATCH
  // -----------------------------
  if (role && role !== effectiveRole) {
    return <div className="p-6">Access Denied</div>;
  }

  return children;
}
